import type {
  ActionIconProps as MantineActionIconProps,
  PolymorphicComponentProps,
} from '@mantine/core';
import { ActionIcon as ActionIconMantine } from '@mantine/core';

import { applyUiId } from '../../Utils/applyComponentGeneratedId';
import classes from './ActionIcon.module.css';

interface ActionIconProps extends MantineActionIconProps {}

const ActionIconDefaults = ActionIconMantine.extend({
  defaultProps: { variant: 'filled', size: 'md', color: 'cobalt' },
  classNames: {
    root: classes.root,
    icon: classes.icon,
  },
});

const ActionIcon: PolymorphicComponentProps<'button', typeof ActionIconMantine> = applyUiId(
  ActionIconMantine,
  'action-icon'
);

export { ActionIcon, ActionIconDefaults };
export type { ActionIconMantine, ActionIconProps };
